import Redux = require("redux");
import {combineReducers, createStore} from "redux";
import Map from 'ol/Map';
import * as cnt from './constants';

export const SET_PERIOD = 'set period';
export const SET_METRIC = 'set metric';
export const SET_MAP = 'set map';
export const SET_SHOW_INTERSTATE = 'set show interstate';
export const SET_SHOW_OTHER = 'set show other';
export const SET_LEFT_YEAR = 'SET_LEFT_YEAR';
export const SET_RIGHT_YEAR = 'SET_RIGHT_YEAR';

// let LEFT_YEAR = cnt.LEFT_YEAR;
// let RIGHT_YEAR = cnt.RIGHT_YEAR;


// let valsMetrics = cnt.valsMetrics;
// export const valsMetricsDescrip = ['level of travel time reliability (ratio)', 'truck travel time reliability (index)', 'person-hours'];

// export const valsInterstate = ['Interstate', 'Non Interstate'];
// export const valsInterstateDescrip = ['Interstate', 'Non Interstate'];

// let valsTimePeriod = cnt.valsTimePeriod;
// export const valsTimePeriodDescrip = ['AM Peak', 'Mid Day', 'PM Peak', 'Overnight', 'Weekend', 'Maximum'];


export interface iSetPeriod extends Redux.Action {
    period: string
}

export interface iSetMetric extends Redux.Action {
    metric: string
}

export interface iSetMap extends Redux.Action{
    map: Map;
}

export interface iSetShowRoads extends Redux.Action {
    show: boolean
}

export interface iSetYear extends Redux.Action {
    year: number
}

function map(state: Map = null, action: iSetMap){
    if (action.type == SET_MAP){
        return action.map
    } else {
        return state;
    }
}


function metric(state: string = cnt.valsMetrics[0], action: iSetMetric) {
    if (action.type == SET_METRIC) {
        return action.metric;
    } else {
        return state;
    }
}

function period(state: string = cnt.valsTimePeriod[0], action: iSetPeriod) {
    if (action.type == SET_PERIOD) {
        return action.period;
    } else {
        return state;
    }
}

function showInterstate(state: boolean = true, action: iSetShowRoads) {
    if (action.type == SET_SHOW_INTERSTATE) {
        return action.show;
    } else {
        return state;
    }
}

function showOther(state: boolean = false, action: iSetShowRoads) {
    if (action.type == SET_SHOW_OTHER) {
        return action.show;
    } else {
        return state;
    }
}

function leftYear(state: number = cnt.LEFT_YEAR, action: iSetYear) {
    if (action.type == SET_LEFT_YEAR){
        return action.year;
    } else {
        return state;
    }
}

function rightYear(state: number = cnt.RIGHT_YEAR, action: iSetYear) {
    if (action.type == SET_RIGHT_YEAR){
        return action.year;
    } else {
        return state;
    }
}



export const store = createStore(
    combineReducers({metric, period, showInterstate, showOther, map, leftYear, rightYear})
);


export interface iState {
    metric: string;
    period: string;
    showInterstate: boolean;
    showOther: boolean;
    map: Map;
    leftYear: number;
    rightYear: number;
}


export function getState(): iState {
    return store.getState() as iState;
}
